import { useMemo } from 'react';
import Helmet from '../lib/Helmet';
import * as HL from '../lib/heatLoad';
import { CATALOGUE } from '../data/catalogue';
import { PRICES, STOCK } from '../data/pricing';
import { SERIES } from '../data/highlights';
import { STATIONS } from '../data/indiaClimate';
import { AC_SPECS } from '../data/acSpecs';
import { roomACs, roomComparison } from '../data/roomDay';
import { pickGuideModels, usedSources } from '../data/guideInverter';
import {
  STARS_SEO, STARS_UPDATED, STARS_SOURCES, SIZES, HOT_ROOM, pairOf, likePair, roomPayback, starsGrid, starsContent,
} from '../data/guideStars';
import { GuideHeader, GuideBody } from '../components/guide/GuideParts';
import CostRace from '../components/guide/CostRace';

// Route: /blog/3-star-vs-5-star-ac — AC guide 4, rebuilt 20 Oct 2026 to
// GUIDES_PLAYBOOK.md section 3. Every word comes from starsContent() in
// data/guideStars.js, which scripts/guide-pages.js reads too.

export default function StarsGuide() {
  const { c, pair, S } = useMemo(() => {
    const picks = (size) => pickGuideModels({ catalogue: CATALOGUE, prices: PRICES, stock: STOCK, series: SERIES, size });
    // Like-for-like pairs (same Daikin line, same kit) where the catalogue has them.
    const pairs = SIZES.map((s) => likePair({ catalogue: CATALOGUE, prices: PRICES, stock: STOCK, series: SERIES, size: s }) || pairOf(picks(s), s)).filter(Boolean);
    const p = pairs.find((x) => x.size === '1.5') || pairs[0];
    const acs = roomACs({ catalogue: CATALOGUE, prices: PRICES, stock: STOCK, series: SERIES, specs: AC_SPECS });
    const both = [p.three, p.five].map((x) => acs.list.find((a) => a.model.id === x.model.id)
      || (AC_SPECS[x.model.id] ? { ...x, spec: AC_SPECS[x.model.id] } : null)).filter(Boolean);
    const runPair = (room) => (both.length === 2 ? roomPayback(p, roomComparison(HL, STATIONS[room.city], room, both)) : null);
    const content = starsContent(pairs, starsGrid(runPair), runPair(HOT_ROOM));
    return { c: content, pair: p, S: usedSources(STARS_SOURCES, content) };
  }, []);

  return (
    <>
      <Helmet>
        <title>{STARS_SEO.title}</title>
        <meta name="description" content={STARS_SEO.meta} />
        <meta property="og:title" content={STARS_SEO.title} />
        <meta property="og:description" content={STARS_SEO.meta} />
      </Helmet>
      <main className="bg-white pb-16 pt-16 lg:pt-20">
        <article className="mx-auto max-w-[760px] px-4 text-base leading-relaxed text-gray-900">
          <GuideHeader seo={STARS_SEO} updated={STARS_UPDATED} crumb={STARS_SEO.crumb} />
          <GuideBody c={c} sources={S} current="3-star-vs-5-star-ac" ctaSource="guide_stars"
            ctaTitle="Want help choosing the right star rating?"
            watch={<CostRace pair={pair} watch={c.watch} sources={S} />} />
        </article>
      </main>
    </>
  );
}
